import { render } from "./ModelCollection.vue?vue&type=template&id=55646680"
import script from "./ModelCollection.vue?vue&type=script&lang=js"
export * from "./ModelCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__